import { render } from "./UiJsonReadOnly.pug?vue&type=template&id=7f602e3d&lang=pug"
import script from "./UiJsonReadOnly.js?vue&type=script&lang=js"
export * from "./UiJsonReadOnly.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__